<template>
  <generic-modal
    :title="$t('whatsapp message')"
    ref="generic_modal"
    :is_wide="true"
  >
    <form>
      <div class="columns">
        <!-- <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('emitter')"
              :placeholder="$t('emitter')"
              url="/whatsapp/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div> -->
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('template')"
              :placeholder="$t('template')"
              url="/whatsapp/template/catalog"
              name_field="name"
              value_field="template_id"
              @selected="set_template"
              ref="template_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone number") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.phone_number" />
            </div>
          </div>
        </div>
      </div>

      <div class="field" v-if="meta.arguments">
        <label class="label">{{ $t("arguments") }}</label>
        <div class="tag" v-if="meta.arguments.length == 0">
          {{ $t("no arguments") }}
        </div>
        <div
          class="field has-addons"
          v-for="(arg, aidx) in meta.arguments"
          :key="aidx"
        >
          <div class="control">
            <div class="button is-info">{{ arg.name }}</div>
          </div>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('value')"
              v-model="meta.arguments[aidx].value"
            />
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("message") }}</label>
        <div class="control">
          <textarea class="textarea" v-model="meta.message" rows="4"></textarea>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-send"></i>
        </span>
        <span>{{ $t("send") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { cloneDeep } from "lodash";

export default {
  name: "WhatsappMessageModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.phone_number || !v.meta.template_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.meta.phone_number = "52183947";
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/whatsapp/message", data)
        .then((r) => {
          console.log("message created", r);
          // v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        phone_number: "",
        // profile_id: undefined,
        template_id: undefined,
        message: "",
        arguments: [],
      };
      v.error = "";
      // v.$refs.profile_dropdown.clear();
      v.$refs.template_dropdown.clear();
    },
    // set_profile(profile) {
    //   let v = this;
    //   if (profile && profile.profile_id) {
    //     v.meta.profile_id = profile.profile_id;
    //   }
    // },
    set_template(template) {
      let v = this;
      if (template && template.template_id) {
        v.meta.template_id = template.template_id;
        v.meta.message = template.settings.message;
      }
    },
    calculate_variables() {
      let v = this;
      let argums = [];

      if (v.meta.message) {
        let regex = /\{\{[a-zA-Z_0-9]*\}\}/gi;
        let __args = v.meta.message.match(regex);
        if (__args) {
          argums = argums.concat(
            __args.map((v) => {
              return { name: v, value: "" };
            })
          );
        }
      }

      let args_ = [];
      for (let index = 0; index < argums.length; index++) {
        const __arg = argums[index];
        let trgt = args_.find((_arg) => {
          return _arg.name == __arg.name;
        });
        if (!trgt) {
          args_.push(__arg);
        }
      }

      if (!v.meta.arguments) v.meta.arguments = [];

      let filtered = v.meta.arguments.filter((arg) => {
        return args_.find((_arg) => {
          return _arg.name == arg.name;
        });
      });
      args_ = args_.map((arg) => {
        let trgt = filtered.find((_arg) => {
          return _arg.name == arg.name;
        });
        if (trgt) {
          return trgt;
        } else {
          return arg;
        }
      });

      v.meta.arguments = cloneDeep(args_);
    },
  },
  mounted() {},
  created() {},
  watch: {
    "meta.message": function () {
      let v = this;
      v.calculate_variables();
    },
  },
};
</script>
<style></style>
